import React, { useEffect, useState } from "react";
import { s360ConfigService } from "../../../Services/S360Config";
import { convertEpochToTimestamp} from "../../../../utils/dateConversion";
import apiService from "../../../Services/APIService";
import flowMemorySingleton from "../../../Services/FlowMemorySingleton";

function NCXTranscriptFileView(props) {
    const { fileName, fileUrl, id, creator, senderId, receivedTimestamp, senderName, messageId, messageSubType } = props;
      const [agentImage, setAgentImage] = useState(false);

    const senderNameStyle = {
        fontWeight: "bold",
        marginBottom: "0.25rem",
        fontSize: "x-small",
    };

    const generateAgentAvatar = () => {
        if (s360ConfigService.config?.sandBox) {
        return (
            <svg
            width="30"
            height="30"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            style={{
                marginRight: "8px",
            }}
            >
            <circle
                cx="50"
                cy="50"
                r="48"
                stroke="#D1D5DB"
                strokeWidth="4"
                fill="#F9FAFB"
            />
            <circle cx="50" cy="35" r="15" fill="#9CA3AF" />
            <path
                d="M20 80c0-16.57 13.43-30 30-30s30 13.43 30 30"
                fill="#9CA3AF"
            />
            </svg>
        );
        }
        if (agentImage) {
        return (
            <img
            src={agentImage}
            alt=""
            style={{
                width: "30px",
                height: "30px",
                borderRadius: "20px",
                marginRight: "8px",
                objectFit: "cover",
            }}
            />
        )
        }
    };

    const fetchUserImage = async (senderId, messageSubType) => {
        try {
            let imgData;

            if (messageSubType === "AIEMPLOYEE") {
                imgData = await apiService.getAIEmployeeImage(senderId);
                flowMemorySingleton.setCurrentAIEmployeeImageUrl(imgData?.data?.imageURL);
                flowMemorySingleton.setCurrentAIEmployeeUserId(senderId);
                setAgentImage(imgData?.data?.imageURL);
            } else {
                imgData = await apiService.getAgentImage(senderId);
                flowMemorySingleton.setCurrentAgentImageUrl(imgData?.data?.signedURL);
                flowMemorySingleton.setCurrentAgentUserId(senderId);
                setAgentImage(imgData?.data?.signedURL);
            }
        } catch (error) {
            console.error(`Failed to fetch ${messageSubType === "AIEMPLOYEE" ? "AI Employee" : "agent"} image:`, error);
            // Don't set image on error - will show name without avatar
        }
    };

    useEffect(() => {
        const isAgent = creator === "AGENT";
        const isAIEmployee = creator === "BOT" && messageSubType === "AIEMPLOYEE";

        if (isAgent || isAIEmployee) {
            if (isAIEmployee) {
                if (senderId !== flowMemorySingleton.getCurrentAIEmployeeUserId()) {
                    fetchUserImage(senderId, messageSubType);
                } else {
                    setAgentImage(flowMemorySingleton.getCurrentAIEmployeeImageUrl());
                }
            } else {
                if (senderId !== flowMemorySingleton.getCurrentAgentUserId()) {
                    fetchUserImage(senderId, messageSubType);
                } else {
                    setAgentImage(flowMemorySingleton.getCurrentAgentImageUrl());
                }
            }
        }
    }, [creator, senderId, messageSubType])
    
    return (
        <div style={{ width: '95vw', display: 'flex', flexDirection: 'column', alignItems: ["USER", "CUSTOMER"].includes(creator) ? 'flex-end' : 'flex-start' }}>
            {senderName &&
                (creator === "AGENT" || (creator === "BOT" && messageSubType === "AIEMPLOYEE")) && (
                <div
                    style={{...senderNameStyle, paddingLeft: '40px'}}
                    className="sender-name-agent"
                    key={`${messageId}-sendername`}
                >
                    {senderName && senderName()} - {convertEpochToTimestamp(receivedTimestamp)}
                </div>
            )}
            <div key={`${id}-transcript-file`} style={{ width: '95vw', padding: '16px', display: 'flex', flexDirection: 'row', justifyContent: ["USER", "CUSTOMER"].includes(creator) ? 'flex-end' : 'flex-start' }}>
                {(creator && (creator === "AGENT" || (creator === "BOT" && messageSubType === "AIEMPLOYEE")) && senderId && s360ConfigService?.config?.configDetails?.showAgentInfo && agentImage) && generateAgentAvatar()}
                <div style={{ border: '1px solid #d9d9d9', borderRadius: '9px', padding: '16px' }}>
                    <a href={fileUrl} style={{ color: s360ConfigService?.config?.configDetails?.primaryColor || "#015fe" }}>{fileName}</a>
                </div>
            </div>
        </div>
    )
}

export default NCXTranscriptFileView;